import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { buildOptions } from "../utils";
import moment from "moment";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

class TreatmentCenterFormModal extends Component {
  state = {
    loading: false
  }

  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentTreatmentCenters(treatmentCenter) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          treatment_centers_attributes: [treatmentCenter]
        }
      })
    })
  }

  deleteTreatmentCenter() {
    const { treatmentCenter, deleteTreatmentCenter, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentTreatmentCenters({
      id: treatmentCenter.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteTreatmentCenter(treatmentCenter);
      if (isStaffApp) {
        alert("Treatment center deleted successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  saveTreatmentCenter() {
    const { treatmentCenter, updateTreatmentCenters, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentTreatmentCenters(treatmentCenter).then((data) => {
      this.setState({ loading: false });
      updateTreatmentCenters(data.treatment_centers);
      if (isStaffApp) {
        alert("Changes to treatment center saved successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveTreatmentCenterFunction = (e) => {
    this.props.dispatch(this.saveTreatmentCenter())
  }

  componentDidMount() {
    document.addEventListener('saveTreatmentCenter', this.saveTreatmentCenterDispatch)
  }

  componentWillUnmount() {
    document.removeEventListener('saveTreatmentCenter', this.saveTreatmentCenterDispatch)
  }

  render() {
    const {
      kind,
      name,
      started_at,
      ended_at,
      reason_for_discharge,
      street_address,
      city,
      state,
      zip_code,
      notes
    } = this.props.treatmentCenter;
    const kindOptions = buildOptions(["IOP", "OP", "Residential", "Detox"]);
    const kindValue = kindOptions.find((option) => option.value === kind);
    const reasonForDischargeOptions = buildOptions(["Financial", "At Staff Request", "Relapsed", "Normal Transition"])
    const reasonForDischargeValue = reasonForDischargeOptions.find((option) => option.value === reason_for_discharge);
    const { isStaffApp, hasDelete, hasEdit } = this.props

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Treatment Center</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="treatmentCenterKind">
                <Form.Label>Kind</Form.Label>
                <Creatable
                  options={kindOptions}
                  value={kindValue}
                  onChange={(option) => {
                    this.handleChange("kind", option.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterName">
                <Form.Label>Facility Name</Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => {
                    this.handleChange('name', e.target.value)
                  }} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="treatmentCenterAdmittedAt">
                    <Form.Label>Admitted At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={started_at ? moment(started_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'started_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="treatmentCenterDischargedAt">
                    <Form.Label>Discharged At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={ended_at ? moment(ended_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'ended_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="treatmentCenterReasonForDischarge">
                <Form.Label>Reason For Discharge</Form.Label>
                <Creatable
                  options={reasonForDischargeOptions}
                  value={reasonForDischargeValue}
                  onChange={(option) => {
                    this.handleChange("reason_for_discharge", option.value)
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterStreetAddress">
                <Form.Label>Street Address</Form.Label>
                <Form.Control
                  value={street_address}
                  onChange={(e) => {
                    this.handleChange("street_address", e.target.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterCity">
                <Form.Label>City</Form.Label>
                <Form.Control
                  value={city}
                  onChange={(e) => {
                    this.handleChange("city", e.target.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterState">
                <Form.Label>State</Form.Label>
                <Form.Control
                  value={state}
                  onChange={(e) => {
                    this.handleChange("state", e.target.value)
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterZip">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  value={zip_code}
                  onChange={(e) => {
                    this.handleChange("zip_code", e.target.value)
                  }} />
              </Form.Group>
              <Form.Group controlId="treatmentCenterNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => {
                    this.handleChange("notes", e.target.value)
                  }} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Kind</Form.Label>
                <div className="form-control-plaintext">{kind || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Facility Name</Form.Label>
                <div className="form-control-plaintext">{name || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Admitted At</Form.Label>
                    <div className="form-control-plaintext">{started_at ? moment(started_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Discharged At</Form.Label>
                    <div className="form-control-plaintext">{ended_at ? moment(ended_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Reason For Discharge</Form.Label>
                <div className="form-control-plaintext">{reason_for_discharge || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Street Address</Form.Label>
                <div className="form-control-plaintext">{street_address || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>City</Form.Label>
                <div className="form-control-plaintext">{city || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>State</Form.Label>
                <div className="form-control-plaintext">{state || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Zip</Form.Label>
                <div className="form-control-plaintext">{zip_code || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ?
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                disabled={this.state.loading}
                variant="outline-danger"
                onClick={() => this.deleteTreatmentCenter()}>
                Delete
              </Button>
            }
            <Button
              disabled={this.state.loading}
              variant="info"
              onClick={() => this.saveTreatmentCenter()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <>
            {
              this.props.action == 'edit' && hasDelete &&
              <div className="p-4">
                <Button
                  disabled={this.state.loading}
                  variant="outline-danger w-100"
                  onClick={() => this.deleteTreatmentCenter()}>
                  Delete
                </Button>
              </div>
            }
          </>
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.treatmentCenterModal.show,
    treatmentCenter: state.ui.treatmentCenterModal.treatmentCenter,
    resident: state.resident,
    organizationName: state.organization.name,
    action: state.ui.treatmentCenterModal.action,
    config: state.config,
    isStaffApp: state.config.isStaffApp,
    resident_tabs: state.config.resident_tabs,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'treatment_center_history'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "treatmentCenter" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "treatmentCenter", name, value }
      });
    },
    updateTreatmentCenters: (treatmentCenters) => {
      dispatch({
        type: "UPDATE_TREATMENT_CENTERS",
        payload: { treatmentCenters }
      });
    },
    createTreatmentCenter: (treatmentCenter) => {
      dispatch({
        type: "CREATE_TREATMENT_CENTER",
        payload: { treatmentCenter }
      });
    },
    deleteTreatmentCenter: (treatmentCenter) => {
      dispatch({
        type: "DELETE_TREATMENT_CENTER",
        payload: { treatmentCenter }
      })
    },
    dispatch: (func) => dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(TreatmentCenterFormModal));
